/* Sem Costura — Vitrine própria de avaliações (Okendo data v3.0)
 * Cursor-based pagination. Delegação de eventos no container #reviews.
 * Sem dado = não renderiza. Erro de API = console.error + esconde seção.
 */
(function () {
  var root = document.getElementById('reviews');
  if (!root) return;

  var API = 'https://api.okendo.io/v1';
  var subscriber = root.dataset.subscriber;
  var productId = root.dataset.productId; // "shopify-123"
  var listEl = root.querySelector('[data-rv-list]');
  var moreBtn = root.querySelector('[data-rv-more]');
  var chipsEl = root.querySelector('[data-rv-chips]');
  var sortSel = root.querySelector('[data-rv-sort]');
  var bySizeEl = root.querySelector('[data-rv-bysize]');
  var bySizeRow = root.querySelector('[data-rv-bysize-row]');
  var tpl = root.querySelector('[data-rv-tpl-item]');
  var topicsEl = root.querySelector('[data-rv-topics]');

  var state = {
    all: [],           // acumulado do servidor (todas páginas puxadas)
    filterRating: 0,   // 0 = sem filtro
    filterTopic: '',   // vazio = sem filtro
    sort: 'date_desc',
    nextUrl: null,
    loading: false,
    firstBatchDone: false,
  };

  // ---- Bootstrap SSR: primeiro lote e nextUrl vêm do metafield -----------
  function readBootstrap() {
    var boot = root.querySelector('script[data-rv-bootstrap]');
    if (boot) {
      try { return JSON.parse(boot.textContent || '{}'); }
      catch (e) { console.warn('[reviews] bootstrap JSON inválido', e); }
    }
    // Fallback: snippet cru com <script data-oke-metafield-data>
    var raw = root.querySelector('[data-rv-snippet-raw]');
    if (raw) {
      var s = raw.querySelector('script[data-oke-metafield-data]');
      if (s) { try { return JSON.parse(s.textContent || '{}'); } catch (e) { console.warn('[reviews] snippet JSON inválido', e); } }
    }
    return null;
  }

  function fmtDate(iso) {
    try {
      var d = new Date(iso);
      return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch (e) { return ''; }
  }
  function initials(name) {
    if (!name) return '?';
    var parts = String(name).trim().split(/\s+/);
    return (parts[0][0] + (parts[1] ? parts[1][0] : '')).toUpperCase();
  }

  function renderList() {
    var items = state.all.slice();
    if (state.filterRating) items = items.filter(function (r) { return r.rating === state.filterRating; });
    if (state.filterTopic) {
      var t = state.filterTopic;
      items = items.filter(function (r) {
        var hay = ((r.body || '') + ' ' + (r.title || '')).toLowerCase();
        return hay.indexOf(t) !== -1;
      });
    }
    switch (state.sort) {
      case 'date_asc': items.sort(function (a, b) { return new Date(a.dateCreated) - new Date(b.dateCreated); }); break;
      case 'rating_desc': items.sort(function (a, b) { return b.rating - a.rating || new Date(b.dateCreated) - new Date(a.dateCreated); }); break;
      case 'rating_asc': items.sort(function (a, b) { return a.rating - b.rating || new Date(b.dateCreated) - new Date(a.dateCreated); }); break;
      default: items.sort(function (a, b) { return new Date(b.dateCreated) - new Date(a.dateCreated); });
    }
    listEl.innerHTML = '';
    if (!items.length) {
      var li = document.createElement('li');
      li.className = 'rv2-empty';
      li.textContent = 'Nenhuma avaliação encontrada com esse filtro.';
      listEl.appendChild(li);
      return;
    }
    var frag = document.createDocumentFragment();
    items.forEach(function (r) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      var name = (r.reviewer && r.reviewer.displayName) || 'Anônimo';
      node.querySelector('[data-avatar]').textContent = initials(name);
      node.querySelector('[data-name]').textContent = name;
      var v = node.querySelector('[data-verified]');
      if (r.reviewer && r.reviewer.isVerified) v.hidden = false;
      var stars = node.querySelector('[data-stars]');
      var pct = Math.max(0, Math.min(5, Number(r.rating) || 0)) * 20;
      stars.style.setProperty('--rs-fill', pct + '%');
      node.querySelector('[data-stars-fill]').style.width = pct + '%';
      stars.setAttribute('aria-label', r.rating + ' de 5 estrelas');
      var timeEl = node.querySelector('[data-date]');
      timeEl.textContent = fmtDate(r.dateCreated);
      timeEl.setAttribute('datetime', r.dateCreated || '');
      node.querySelector('[data-title]').textContent = r.title || '';
      node.querySelector('[data-text]').textContent = r.body || '';
      if (r.productVariantName) {
        var sz = node.querySelector('[data-size]');
        sz.hidden = false;
        sz.textContent = 'Tamanho comprado: ' + r.productVariantName;
      }
      frag.appendChild(node);
    });
    listEl.appendChild(frag);
  }

  function renderChips() {
    chipsEl.innerHTML = '';
    if (state.filterRating) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'rv2-chip';
      chip.setAttribute('data-rv-clear', 'rating');
      chip.innerHTML = state.filterRating + ' ★ <span aria-hidden="true">×</span>';
      chipsEl.appendChild(chip);
    }
    if (state.filterTopic) {
      var chip2 = document.createElement('button');
      chip2.type = 'button';
      chip2.className = 'rv2-chip';
      chip2.setAttribute('data-rv-clear', 'topic');
      chip2.innerHTML = state.filterTopic + ' <span aria-hidden="true">×</span>';
      chipsEl.appendChild(chip2);
    }
  }

  function renderBySize() {
    var map = {};
    state.all.forEach(function (r) {
      var s = (r.productVariantName || '').trim();
      if (!s) return;
      if (!map[s]) map[s] = { sum: 0, n: 0 };
      map[s].sum += Number(r.rating) || 0;
      map[s].n += 1;
    });
    var keys = Object.keys(map);
    if (keys.length < 2) { bySizeEl.hidden = true; return; }
    // ordenação humana básica
    var order = ['PP', 'P', 'M', 'G', 'GG', 'XG', 'XGG', 'EG', 'EGG'];
    keys.sort(function (a, b) {
      var ia = order.indexOf(a.toUpperCase()); var ib = order.indexOf(b.toUpperCase());
      if (ia === -1 && ib === -1) return a.localeCompare(b);
      if (ia === -1) return 1; if (ib === -1) return -1;
      return ia - ib;
    });
    bySizeRow.innerHTML = '';
    keys.forEach(function (k) {
      var d = map[k];
      var avg = (d.sum / d.n).toFixed(1).replace('.', ',');
      var cell = document.createElement('div');
      cell.className = 'rv2-bysize__cell';
      cell.innerHTML = '<div class="rv2-bysize__k">' + k + '</div>' +
                       '<div class="rv2-bysize__avg">' + avg + ' ★</div>' +
                       '<div class="rv2-bysize__n">(' + d.n + ')</div>';
      bySizeRow.appendChild(cell);
    });
    bySizeEl.hidden = false;
  }

  function fetchPage(url) {
    state.loading = true;
    if (moreBtn) moreBtn.setAttribute('aria-busy', 'true');
    return fetch(url, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        var revs = (data && data.reviews) || [];
        state.all = state.all.concat(revs.filter(function (r) { return r.status === 'approved'; }));
        var nu = data && (data.reviewsNextUrl || data.nextUrl);
        state.nextUrl = nu ? (nu.indexOf('http') === 0 ? nu : (API + nu)) : null;
        if (moreBtn) moreBtn.hidden = !state.nextUrl;
        renderList();
        renderBySize();
      })
      .catch(function (err) {
        console.error('[reviews] falha ao carregar Okendo:', err);
        // Se já temos SSR, não escondemos a seção — apenas o botão.
        if (!state.firstBatchDone && !state.all.length) root.hidden = true;
        if (moreBtn) moreBtn.hidden = true;
      })
      .finally(function () {
        state.loading = false;
        state.firstBatchDone = true;
        if (moreBtn) moreBtn.removeAttribute('aria-busy');
      });
  }

  // ---- Boot: hidrata a partir do SSR; API só entra no "Mostrar mais" ------
  var boot = readBootstrap();
  if (boot && boot.reviews && boot.reviews.length) {
    state.all = boot.reviews.slice();
    state.nextUrl = boot.reviewsNextUrl || null;
    if (state.nextUrl && state.nextUrl.indexOf('http') !== 0) state.nextUrl = API + state.nextUrl;
    state.firstBatchDone = true;
    // Remove itens SSR e re-renderiza com JS (mantém a mesma marcação e permite ordenar/filtrar)
    listEl.querySelectorAll('[data-rv-server]').forEach(function (n) { n.remove(); });
    renderList();
    renderBySize();
    if (moreBtn) moreBtn.hidden = !state.nextUrl;
  } else {
    // Sem bootstrap: cai para a API pública (comportamento legado)
    var loading = root.querySelector('[data-rv-loading]');
    fetchPage(API + '/stores/' + subscriber + '/products/' + productId + '/reviews?limit=20')
      .then(function () {
        if (loading && loading.parentNode) loading.remove();
        if (!state.all.length) { root.hidden = true; }
      });
  }

  // Delegação no container estável — nunca no nó substituído
  root.addEventListener('click', function (e) {
    var barBtn = e.target.closest('[data-rv-filter-rating]');
    if (barBtn) {
      var r = Number(barBtn.getAttribute('data-rv-filter-rating')) || 0;
      state.filterRating = state.filterRating === r ? 0 : r;
      renderChips(); renderList();
      return;
    }
    var clr = e.target.closest('[data-rv-clear]');
    if (clr) {
      var kind = clr.getAttribute('data-rv-clear');
      if (kind === 'topic') state.filterTopic = '';
      else state.filterRating = 0;
      renderChips(); renderList();
      return;
    }
    var tBtn = e.target.closest('[data-rv-topic]');
    if (tBtn) {
      var t = (tBtn.getAttribute('data-rv-topic') || '').toLowerCase();
      state.filterTopic = state.filterTopic === t ? '' : t;
      // pintar estado ativo
      if (topicsEl) topicsEl.querySelectorAll('[data-rv-topic]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === tBtn && state.filterTopic ? 'true' : 'false');
      });
      renderChips(); renderList();
      return;
    }
    if (e.target.closest('[data-rv-more]')) {
      if (state.nextUrl && !state.loading) fetchPage(state.nextUrl);
      return;
    }
  });

  root.addEventListener('change', function (e) {
    if (e.target && e.target.matches('[data-rv-sort]')) {
      state.sort = e.target.value;
      renderList();
    }
  });
})();